import { YayoyakiFormatter } from '@taxdown/kami-sama/dist/kamiSama/yayoyakiFormatter';

export const transformInstallmentToOptions = (
  arrayData: number[][]
): { value: string; label: string }[] => {
  const arrayOptions = arrayData.map(item => {
    const value = item.reduce((acc, curr) => acc + curr, 0);
    const maxVal = Math.max(...item);
    const numPayments = item.length;
    const label = `${numPayments} ${
      numPayments > 1 ? 'pagos' : 'pago'
    } de ${YayoyakiFormatter.formatAmountMxn(maxVal)}`;
    return {
      value: `${YayoyakiFormatter.formatAmountMxn(value)}`,
      label,
    };
  });

  return arrayOptions;
};
